import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import Setor from "model/administracao/cadastro/Setor";
import Usuario from "model/administracao/cadastro/Usuario";
import GerarAuditoriaDto from "model/auditoria5s/gerar/GerarAuditoriaDto";
import GerarAuditoriaItemDto from "model/auditoria5s/gerar/GerarAuditoriaItemDto";
import SetorPlanoAuditoria from "model/auditoria5s/planoDeAuditoria/SetorPlanoAuditoria";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import AuditoriaService from "service/auditoria5s/AuditoriaService";
import { PeriodicidadeService } from "service/periodicidade/PeriodicidadeService";

type Props = {
    visible: boolean;
    onHide: () => void;
    onConfirm: () => void;
}

const periodicidadeService = new PeriodicidadeService();
const auditoriaService = new AuditoriaService();
export default function ModalGerarNovasAuditorias(props: Props) {

    const { msgAlerta, msgErro } = useToastContext();

    const [setoresSelecionados, setSetoresSelecionados] = useState<Setor[]>([]);
    const [setoresDisponiveis, setSetoresDisponiveis] = useState<Setor[]>([]);

    const [usuariosDisponiveis, setUsuariosDisponiveis] = useState<Usuario[]>([]);

    const [dados, setDados] = useState<GerarAuditoriaDto>(new GerarAuditoriaDto());

    const [screenIndex, setScreenIndex] = useState(0);


    useEffect(() => {
        auditoriaService.getSetoresDisponiveis().then(response => setSetoresDisponiveis(response)).catch(() => setSetoresDisponiveis([]));
        auditoriaService.getUsuariosDisponiveis().then(response => setUsuariosDisponiveis(response)).catch(() => setUsuariosDisponiveis([]));
    }, [props.visible]);

    useEffect(() => {
        let itens = [...dados.itens];
        dados.itens.forEach((item: any) => {
            let setor = setoresSelecionados.find((setor: Setor) => {
                return setor.planos.find((planoSetor: SetorPlanoAuditoria) => {
                    return planoSetor.id == item.ligacao?.id
                })
            })
            if (!setor) {
                itens.splice(itens.indexOf(item), 1)
            }
        })
        setDados({ ...dados, itens: itens })

    }, [setoresSelecionados])

    const expendedRowTemplate = (data: Setor) => {

        return (

            <div style={{ width: '100%', display: "flex", paddingTop: 10, paddingBottom: 10, justifyContent: "center" }}>
                <div style={{ width: "80%" }} >
                    <Label className="col-sm-12" >Selecione os planos</Label>
                    <div className="col-sm-12">
                        <DataTable
                            emptyMessage="Nenhum registro encontrado"
                            value={data.planos}
                            selectionMode='checkbox'
                            selection={dados.itens.map((item: any) => item.ligacao)}
                            onSelectionChange={(e) => {
                                let itens = [...dados.itens];
                                (e.value as SetorPlanoAuditoria[]).forEach((ligacao: SetorPlanoAuditoria) => {
                                    if (!itens.find((item: any) => item.ligacao?.id == ligacao.id)) {
                                        itens.push({ ligacao: ligacao, usuario: ligacao.auditor })
                                    }
                                })
                                dados.itens.forEach((item: any) => {
                                    if ((e.value as SetorPlanoAuditoria[]).indexOf(item.ligacao as SetorPlanoAuditoria) == -1) {
                                        itens.splice(itens.indexOf(item), 1)
                                    }
                                })
                                setDados({ ...dados, itens: itens })
                            }}
                            dataKey="id"
                            tableStyle={{ minWidth: '100%' }}
                        >
                            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                            <Column field="planoAuditoria.nome" header="Nome"></Column>
                            <Column field="auditor.nome" header="Auditor"></Column>
                            <Column header="Limite" body={(rowData: SetorPlanoAuditoria) => {
                                return rowData.limite?.ativa ?
                                    rowData.limite.periodo + " " + periodicidadeService.getTipoPeriodo(rowData.limite.tipoPeriodo)?.label
                                    : "Inativo"

                            }} />
                        </DataTable>
                    </div>

                </div>
            </div>

        )
    }

    function validar() {
        if (dados.itens.length < 1) {
            msgAlerta("Planos insuficientes", "Seleciona pelo menos um plano");
            return false;
        }
        if (!dados.sortearUsuarios) {
            for (const item of dados.itens) {
                if (!item.usuario) {
                    msgAlerta("Usuário não selecionado", "Selecione um usuário para cada plano");
                    return false;
                }
            }
        }

        return true;
    }

    function gerarAuditorias() {
        if (!validar()) {
            return;
        }

        auditoriaService.gerarNovaAuditoria(dados).then(e => {
            props.onConfirm();
        }).catch(err => {
            if (err && err.data && err.data.message) {
                falhaGerar(err.data.message);
            } else {
                falhaGerar("Erro ao gerar auditoria");
            }

            console.log(err);
        });
    }

    function falhaGerar(msg: string) {
        msgErro("Erro", msg);
    }

    return <Dialog visible={props.visible}
        onHide={() => {
            setSetoresSelecionados([]);
            props.onHide();
        }}
        header="Selecione os setores para gerar Auditoria"
        footer={<div>
            <Button label="Cancelar" className="p-button-danger" onClick={() => {
                setSetoresSelecionados([]);
                props.onHide();
            }} />
            {screenIndex == 1 && (
                <Button label="Voltar" className="p-button-secondary" onClick={() => {
                    setScreenIndex(0);
                }} />
            )}
            {dados.sortearUsuarios || screenIndex == 1 ? (
                <Button label="Gerar" className="p-button-info" onClick={() => {
                    gerarAuditorias();
                }} />
            ) : (
                <Button label="Próximo" className="p-button-info" onClick={() => {
                    setScreenIndex(1);
                }} />
            )}
        </div>}
    >
        {screenIndex == 0 ? (
            <div>

                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
                    <Checkbox
                        checked={dados.sortearUsuarios} onChange={(e) => setDados({ ...dados, sortearUsuarios: e.checked || false })}
                    />
                    <Label className="col-sm-12" >Sortear usuários</Label>

                </div>
                <div className="row">
                    <div className="col-sm-12">

                        <DataTable
                            header='Setores disponíveis'
                            value={setoresDisponiveis}
                            selectionMode='checkbox'
                            selection={setoresSelecionados}
                            onSelectionChange={(e) => setSetoresSelecionados(e.value as Setor[])}
                            dataKey="id"
                            tableStyle={{ minWidth: '50rem' }}
                            expandedRows={setoresSelecionados}
                            rowExpansionTemplate={expendedRowTemplate}
                            emptyMessage="Nenhum registro encontrado"
                        >
                            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                            <Column field="nome" header="Nome"></Column>
                        </DataTable>

                    </div>
                </div>
            </div>
        ) : (
            <div>
                <DataTable
                    header="Selecionar usuários"
                    value={dados.itens}
                    tableStyle={{ minWidth: '50rem' }}
                    emptyMessage="Nenhum Plano de Auditoria selecionado"
                >
                    <Column field="ligacao.setor.nome" header="Setor"></Column>
                    <Column field="ligacao.planoAuditoria.nome" header="Plano"></Column>
                    <Column header="Limite" body={(rowData: GerarAuditoriaItemDto) => {
                        return rowData.ligacao?.limite?.ativa ?
                            rowData.ligacao?.limite.periodo + " " + periodicidadeService.getTipoPeriodo(rowData.ligacao?.limite.tipoPeriodo)?.label
                            : "Inativo"

                    }} />
                    <Column header="Usuário" style={{ width: 200 }} body={(rowData: GerarAuditoriaItemDto) => (
                        <Dropdown
                            style={{ width: "100%" }}
                            dataKey="id"
                            value={rowData.usuario}
                            options={usuariosDisponiveis}
                            optionLabel="nome"
                            onChange={(e) => {
                                rowData.usuario = e.value;
                                setDados({ ...dados });
                            }}
                            filter
                            filterBy="nome"
                        />
                    )} />

                </DataTable>

            </div>
        )}
    </Dialog>
}